import React, { useState } from 'react';
import { Autocomplete, Box, Button, TextField } from '@mui/material';
import EventCustomFieldInsertModal from './EventCustomFieldInsertModal';

export interface IReplacementOption {
  value?: string;
  label: string;
}

interface IReplacementDropdownProps {
  onInsert: (inputString: string) => void;
}

const REPLACEMENT_OPTIONS: IReplacementOption[] = [
  { value: 'recipient_name', label: 'Recipient Name' },
  { value: 'recipient_first_name', label: 'Recipient First Name' },
  { value: 'recipient_last_name', label: 'Recipient Last Name' },
  { value: 'event_name', label: 'Event Name' },
  { value: 'account_name', label: 'Account Name' },
  { value: 'event_start_date', label: 'Event Start Date' },
  { value: 'event_start_time', label: 'Event Start Time' },
  { value: 'event_end_date', label: 'Event End Date' },
  { value: 'event_end_time', label: 'Event End Time' },
  { value: 'event_type', label: 'Event Type' },
  { value: 'account_manager_name', label: 'Account Manager Name' },
  { value: 'account_manager_email', label: 'Account Manager Email' },
  { value: 'account_manager_phone', label: 'Account Manager Phone' },
  { value: 'account_code', label: 'Account Code' },
  { value: 'event_custom_field', label: 'Event Custom Field' },
];

export default function ReplacementDropdown({ onInsert }: IReplacementDropdownProps) {
  const [replacementOption, setReplacementOption] = useState<IReplacementOption | null>(null);
  const [showModal, setShowModal] = useState(false);

  // Handles inserting the selected replacement option into the editor
  const handleInsertClick = () => {
    if (!replacementOption) return;
    if (replacementOption.value === 'event_custom_field') {
      setShowModal(true);
      return;
    }

    onInsert(`<%= ${replacementOption.value} %>`);
  };

  // Inserts a custom field with the given label into the editor
  const handleInsertField = (fieldLabel: string) => {
    onInsert(`<%= event_custom_field['${fieldLabel}'] %>`);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', width: '100%' }}>
      <Autocomplete<IReplacementOption>
        fullWidth
        options={REPLACEMENT_OPTIONS}
        onChange={(_, value) => setReplacementOption(value)}
        value={replacementOption}
        renderInput={(params) => <TextField {...params} margin="none" sx={{ minWidth: '200px' }} label="Template Replace" />}
      />
      <Button variant="contained" onClick={handleInsertClick}>
        Insert
      </Button>

      <EventCustomFieldInsertModal open={showModal} onClose={() => setShowModal(false)} onInsert={handleInsertField} />
    </Box>
  );
}
